<template>
  <div id="page">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <div v-if="currentPage" class="block-wrapper">
      <div class="content sans lazy-container">
        <div
          v-for="(block, index) in currentPage.acf.description"
          class="block-wrapper"
          :key="index"
        >
          <h3 class="block-heading mb2" v-if="block.block_heading">
            {{ block.block_heading }}
          </h3>
          <div
            v-if="
              block.block_content.columns === '1' ||
              (block.acf_fc_layout === 'person_block' && block.block_content)
            "
            class="block-content"
          >
            <div
              v-html="block.block_content.column_1 || block.block_content"
            ></div>

            <div
              v-if="$route.params.page === 'donate'"
              style="
                display: flex;
                justify-content: center;
                width: 100%;
                margin-top: 2em;
              "
            >
              <div
                id="betterplace_donation_iframe"
                style="
                  background: transparent
                    url('https://www.betterplace.org/assets/new_spinner.gif')
                    275px 20px no-repeat;
                  max-width: 600px;
                  min-width: 250px;
                  width: 100%;
                "
              >
                <strong>
                  Donate now for "Donate to independent investigative work"
                  via
                  <a
                    href="https://www.betterplace.org/en/donate/platform/projects/181890-donate-to-independent-investigative-work"
                  >
                    betterplace.org
                  </a>.
                  The donation is processed by our partner
                  <a href="http://betterplace.org">betterplace.org</a>.
                </strong>
              </div>
            </div>
          </div>
          <div
            v-else-if="block.block_content"
            class="block-content flex two-col"
          >
            <div
              v-html="block.block_content.column_1"
              class="block-column col-6"
            ></div>
            <div
              v-html="block.block_content.column_2"
              class="block-column col-6"
            ></div>
          </div>
          <person-list
            v-if="block.acf_fc_layout === 'person_block'"
            :content="block.people"
          ></person-list>
        </div>

        <person-list
          v-if="this.$route.params.page === 'advisory-board'"
          :content="currentPage.acf.people"
        ></person-list>

        <org-list
          v-if="this.$route.params.page === 'funding'"
          title="Funding Organisations ↘"
          :content="currentPage.acf.funders"
        ></org-list>

        <org-list
          v-if="this.$route.params.page === 'funding'"
          title="Donors ↘"
          :content="currentPage.acf.donors"
        ></org-list>

        <org-list
          v-if="this.$route.params.page === 'funding'"
          title="Collections ↘"
          :content="currentPage.acf.collections"
        ></org-list>
      </div>

      <recognition-table
        id="recognition"
        class="max-width-reader"
        v-if="showRecognition"
        :showTitle="false"
        :content="recognition"
      ></recognition-table>

      <press-table
        id="press"
        class="max-width-reader"
        v-if="showPress"
        :showTitle="false"
        :content="fapress"
      ></press-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SubMenu from "@/components/SubMenu";
import RecognitionTable from "@/components/RecognitionTable";
import PressTable from "@/components/PressTable";
import OrgList from "@/components/OrgList";
import PersonList from "@/components/PersonList";

const BP_SCRIPT_SRC =
  "https://betterplace-assets.betterplace.org/assets/load_donation_iframe.js";

// Restored into #betterplace_donation_iframe when leaving the donate page,
// so the widget re-initializes cleanly if the user navigates back to it.
const BP_FALLBACK_HTML = `
  <strong>
    Donate now for "Donate to independent investigative work" via
    <a href="https://www.betterplace.org/en/donate/platform/projects/181890-donate-to-independent-investigative-work">betterplace.org</a>.
    The donation is processed by our partner
    <a href="http://betterplace.org">betterplace.org</a>.
  </strong>
`;

export default {
  name: "Page",

  data() {
    return {
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img",
      }),
    };
  },

  metaInfo() {
    let title = this.currentPage.title.rendered.replace("&#038;", "&");
    return {
      title: title || "Loading...",
      meta: [
        {
          name: "og:title",
          content: `${process.env.VUE_APP_TITLE} → ${title}`,
        },
        {
          name: "twitter:title",
          content: `${process.env.VUE_APP_TITLE} → ${title}`,
        },
        { name: "og:image", content: "/fa-share-lg.png" },
        { name: "twitter:image", content: "/fa-share-lg.png" },
        {
          name: "og:url",
          content: `${window.location.origin}/${this.$route.fullPath}`,
        },
        { name: "og:type", content: "website" },
        { name: "og:description", content: this.siteDescription() },
        { name: "twitter:description", content: this.siteDescription() },
      ],
    };
  },

  components: {
    RecognitionTable,
    PressTable,
    PersonList,
    OrgList,
    SubMenu,
  },

  mounted: function () {
    this.updatePage();
  },

  beforeUnmount() {
    // In case the component itself is ever destroyed while on the donate page
    this.unloadDonationScript();
  },

  computed: {
    ...mapState(["recognition", "pages", "fapress"]),
    currentPage() {
      let slug = this.$route.params.page;
      if (this.pages.hasOwnProperty(slug)) {
        return this.pages[slug];
      } else {
        return false;
      }
    },
    showRecognition() {
      return this.recognition && this.$route.params.page === "recognition";
    },
    showPress() {
      return this.fapress.length && this.$route.params.page === "press-contact";
    },
  },

  methods: {
    ...mapActions(["getPage", "getfapress"]),
    updatePage() {
      this.$nextTick(function () {
        this.lazyContainer.update();
      });
      if (this.$route.params.page === "press-contact") {
        this.getfapress();
      }
      if (this.$route.params.page === "donate") {
        this.loadDonationScript();
      } else {
        this.unloadDonationScript();
      }
    },
    loadDonationScript() {
      window._bp_iframe = window._bp_iframe || {};
      window._bp_iframe.project_id = 181890; // REQUIRED
      window._bp_iframe.lang = "en";
      window._bp_iframe.width = 600;
      window._bp_iframe.color = "003060";
      window._bp_iframe.background_color = "ffffff";
      window._bp_iframe.default_amount = 50;
      window._bp_iframe.recurring_interval = "single"; // single | monthly | yearly
      window._bp_iframe.bottom_logo = true;

      if (!document.querySelector(`script[src="${BP_SCRIPT_SRC}"]`)) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = BP_SCRIPT_SRC;
        document.head.appendChild(script);
      }
    },
    unloadDonationScript() {
      const script = document.querySelector(`script[src="${BP_SCRIPT_SRC}"]`);
      if (script) {
        script.remove();
      }

      const container = document.getElementById(
        "betterplace_donation_iframe"
      );
      if (container) {
        container.innerHTML = BP_FALLBACK_HTML;
      }

      delete window._bp_iframe;
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.getPage(to.params.page).then(function () {
      next();
    });
  },

  watch: {
    $route() {
      this.updatePage();
    },
  },
};
</script>

<style lang="css" scoped>
.block-wrapper:last-child {
  margin-bottom: 0;
}
#page {
  .block-wrapper {
    margin-bottom: 6em;
  }
}
div.content + section#press {
  margin-top: -4em;
}
</style>